//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.8.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum DefinitionElementType {
    Text = 0,
    Number = 1,
    Datepicker = 2,
    Radio = 3,
    Select = 4,
    Array = 5,
    Section = 6,
    Hidden = 7,
    Phone = 8,
    Email = 9,
    ReadOnly = 10,
    Checkbox = 11,
    TextArea = 12,
    Time = 13,
    Button = 14,
    NutsSelector = 15,
    CpvSelector = 16,
    Change = 17,
    InformationBox = 18,
    InputWithDropdown = 19,
    Alert = 20,
}

export interface BlockFormRuleItem {
    message: string | undefined;
    required: boolean | undefined;
    pattern: string | undefined;
    minLength: number | undefined;
    maxLength: number | undefined;
    minRange: number | undefined;
    maxRange: number | undefined;
    function: string | undefined;
}

export interface BlockConditionItem {
    fieldName: string;
    valueToCompare: string;
    fieldAliasToCompare: string | undefined;
    valueType: ComparisonValueType;
    compareType: string;
    additionalCompareType: string | undefined;
}

export enum ComparisonValueType {
    String = 0,
    Number = 1,
    Boolean = 2,
    Visible = 3,
    Array = 4,
    DateOnly = 5,
    BooleanV2 = 6,
}

export interface FormDefinitionBlockItem {
    name: string;
    businessTerm: string | undefined;
    description: string | undefined;
    visibility: string | undefined;
    repeatable: boolean | undefined;
    alias: string | undefined;
    label: string | undefined;
    placeholder: string | undefined;
    type: DefinitionElementType;
    divStyle: string | undefined;
    labelStyle: string | undefined;
    elementStyle: string | undefined;
    sectionStyle: string | undefined;
    fieldsetStyle: string | undefined;
    disabled: boolean | undefined;
    rules: BlockFormRuleItem[] | undefined;
    conditions: BlockConditionItem[] | undefined;
    fields: FormDefinitionBlockItem[] | undefined;
}
